import axiosInstance from "@/api/axios-instance";

export async function getSubmissions({
  page,
  search,
  department,
  formId,
}: {
  page: number;
  search?: string;
  department?: string;
  formId?: string;
}) {
  const params: Record<string, any> = { page };
  if (search) params.search = search;
  if (department && department !== "ALL") params.department = department;
  if (formId && formId !== "ALL") params.form_id = formId;

  const response = await axiosInstance.get("/submission", { params });

  if (!response.status.toString().startsWith("2")) {
    throw new Error("submissions are not loaded");
  }

  const {
    submissions,
    nextPage,
    lastPage,
    page: currentPage,
    total,
  } = response.data;
  return {
    submissions,
    nextPage,
    lastPage,
    currentPage,
    total,
  };
}
